/// <reference path="../../../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';


    import BlockTypeNaturalKey = Application.Models.BlockTypeNaturalKey;
    import ConnectionType = Application.Models.ConnectionType;
    import PresetPathBlock = Application.Models.PresetPathBlock;
    import IPresetPathBlockConnections = Application.Models.IPresetPathBlockConnections;
    import StickyConnection = Application.Models.StickyConnection;

    export interface IStickyConnectionModalControllerScope extends ng.IScope {
        blocks: {
            srcBlocks: PresetPathBlock[];
            dstBlocks: PresetPathBlock[];
            selected: {
                name?: string;
                srcBlock: PresetPathBlock;
                srcConnection: IPresetPathBlockConnections;
                dstBlock: PresetPathBlock;
                dstConnection: IPresetPathBlockConnections;
            }
        };
        modalClose: () => void;
        modalSave: () => void;
        clear: () => void;
        modalTitle: string;
    }

    export class AddPresetPathsModalController {

        public static templateUrl: string = "decorators/modals/admin/preset-paths/add-preset-paths-modal.html";
        public static id: string = "#id-sticky-connection-modal";
        public static $name: string = "addPresetPathsModal";
        public static $inject: string[] = [
            '$scope',
            'close',
            '$timeout',
            'blocks',
            'presetPathType'
        ];

        private presetPathType: string;

        constructor($scope: IStickyConnectionModalControllerScope,
                    close: (response: {name: string, srcConn: number, dstConn: number}) => void,
                    $timeout: ng.ITimeoutService,
                    blocks: PresetPathBlock[],
                    presetPathType: string) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            blocks = blocks.filter((block: PresetPathBlock) => {
                return block.presetPathBlockConnections.length > 0;
            });

            this.presetPathType = presetPathType;
            $scope.modalTitle = this.presetPathType + " Preset Path creation";
            const sourceBlocks: PresetPathBlock[] = AddPresetPathsModalController.filterSourceBlocks(blocks, this.presetPathType);
            const sinkBlocks: PresetPathBlock[] = AddPresetPathsModalController.filterSinkBlocks(blocks, this.presetPathType);


            this.init(sourceBlocks, sinkBlocks, $scope);

            $scope.$watch('blocks.selected.srcBlock', (newVal: PresetPathBlock, oldVal: PresetPathBlock) => {
                // a source has been selected
                if (newVal !== oldVal) {
                    if (newVal) {
                        $scope.blocks.selected.srcConnection = this.filterBlockConnectionsByConnectionType($scope.blocks.selected.srcBlock, 'OUTPUT')[0];
                        // populating the destination blocks
                        if (!$scope.blocks.selected.dstBlock || $scope.blocks.selected.dstBlock.name === '') {
                            $scope.blocks.dstBlocks =
                                this.filterBlocksByBlockConnection(sinkBlocks, $scope.blocks.selected.srcConnection, 'INPUT');
                        }

                        if (StickyConnection.SRC_PRESETPATH_ORIG.some(naturalKey => naturalKey === newVal.blockTypeNaturalKey)) {
                            if ($scope.blocks.selected.dstBlock
                                    && !StickyConnection.SRC_PRESETPATH_DEST.some(naturalKey => naturalKey === $scope.blocks.selected.dstBlock.blockTypeNaturalKey)) {
                                $scope.blocks.selected.dstBlock = undefined;
                            }
                            $scope.blocks.dstBlocks = this.filterSrcPresetPathDest($scope.blocks.dstBlocks);
                        }
                    }
                }
            });

            $scope.$watch('blocks.selected.dstBlock', (newVal: PresetPathBlock, oldVal: PresetPathBlock) => {
                // a destination has been selected
                if (newVal !== oldVal) {
                    if (newVal) {
                        $scope.blocks.selected.dstConnection = this.filterBlockConnectionsByConnectionType($scope.blocks.selected.dstBlock, 'INPUT')[0];
                        // populating the source blocks
                        if (!$scope.blocks.selected.srcBlock || $scope.blocks.selected.srcBlock.name === '') {
                            $scope.blocks.srcBlocks =
                                this.filterBlocksByBlockConnection(sourceBlocks, $scope.blocks.selected.dstConnection, 'OUTPUT');
                        }

                        if (StickyConnection.SRC_PRESETPATH_DEST.some(naturalKey => naturalKey === newVal.blockTypeNaturalKey)) {
                            if ($scope.blocks.selected.srcBlock
                                    && !StickyConnection.SRC_PRESETPATH_ORIG.some(naturalKey => naturalKey === $scope.blocks.selected.srcBlock.blockTypeNaturalKey)) {
                                $scope.blocks.selected.srcBlock = undefined;
                            }
                            $scope.blocks.srcBlocks = this.filterSrcPresetPathOrig($scope.blocks.srcBlocks);
                        }
                    }
                }
            });

            $scope.modalClose = (): void => {
                close(undefined);
            };

            $scope.modalSave = (): void => {
                if ($scope.blocks.selected.srcBlock && $scope.blocks.selected.srcConnection &&
                    $scope.blocks.selected.dstBlock && $scope.blocks.selected.dstConnection &&
                    $scope.blocks.selected.name && $scope.blocks.selected.name !== '') {
                    close({
                        name: $scope.blocks.selected.name,
                        srcConn: $scope.blocks.selected.srcConnection.blockConnectionId,
                        dstConn: $scope.blocks.selected.dstConnection.blockConnectionId,
                    });
                }
            };

            $scope.clear = (): void => {
                this.init(sourceBlocks, sinkBlocks, $scope);
            };

        }

        private async init(sourceBlocks: PresetPathBlock[], sinkBlocks: PresetPathBlock[], $scope: IStickyConnectionModalControllerScope): Promise<void> {
            $scope.blocks = {
                srcBlocks: [PresetPathBlock.Empty()].concat(sourceBlocks),
                dstBlocks: [PresetPathBlock.Empty()].concat(sinkBlocks),
                selected: {
                    name: $scope.blocks && $scope.blocks.selected ? $scope.blocks.selected.name : '',
                    srcBlock: undefined,
                    srcConnection: undefined,
                    dstBlock: undefined,
                    dstConnection: undefined,
                },
            };
        }

        private  filterSrcPresetPathDest(blocks: PresetPathBlock[]): PresetPathBlock[] {
            return blocks.filter((block: PresetPathBlock) => {
                return StickyConnection.SRC_PRESETPATH_DEST.some(naturalKey => naturalKey === block.blockTypeNaturalKey);
            });
        }

        private  filterSrcPresetPathOrig(blocks: PresetPathBlock[]): PresetPathBlock[] {
            return blocks.filter((block: PresetPathBlock) => {
                return StickyConnection.SRC_PRESETPATH_ORIG.some(naturalKey => naturalKey === block.blockTypeNaturalKey);
            });
        }

        private filterBlocksByBlockConnection(blocks: PresetPathBlock[], blockConnection: IPresetPathBlockConnections, direction: string): PresetPathBlock[] {
            return blocks.filter((block: PresetPathBlock) => {
                return block.presetPathBlockConnections.filter((connection: IPresetPathBlockConnections) => {
                    if (blockConnection) {
                        return connection.direction === direction &&
                            connection.connectionTypeName === this.presetPathType &&
                            connection.push === blockConnection.push;
                    } else {
                        return connection.direction === direction;
                    }
                }).length > 0;
            });
        }

        private filterBlockConnectionsByConnectionType(
            block: PresetPathBlock, direction: string, connectionType: string = this.presetPathType): IPresetPathBlockConnections[] {
                return block.presetPathBlockConnections.filter((connection: IPresetPathBlockConnections) => {
                return connection.direction === direction && connection.connectionTypeName === connectionType;
            }).sort((a1: IPresetPathBlockConnections, a2: IPresetPathBlockConnections) => a1.connectionTypeName.localeCompare(a2.connectionTypeName));
        }

        /**
         * This method filters for a given list of blocks, all blocks whose pipe position is SINK or those that are of
         * SRT_GW_RX type in nature
         * @param blocks
         */
        public static filterSinkBlocks(blocks: PresetPathBlock[], presetPathType: string): PresetPathBlock[] {
            if (Array.isArray((blocks))) {
                return blocks.filter((block: PresetPathBlock) => {
                    return AddPresetPathsModalController.canBePresetPathSink(block, presetPathType);
                }).sort((a1: PresetPathBlock, a2: PresetPathBlock) => a1.name.localeCompare(a2.name));
            }
            return [];
        }

        /**
         * This method filters for a given list of blocks, all blocks whose pipe position is SOURCE or those that are of
         * SRT_GW_TX_LSTN type in nature
         * @param blocks
         */
        public static filterSourceBlocks(blocks: PresetPathBlock[], presetPathType: string): PresetPathBlock[] {
            if (Array.isArray((blocks))) {
                return blocks.filter((block: PresetPathBlock) => {
                    return AddPresetPathsModalController.canBePresetPathSource(block, presetPathType);
                }).sort((a1: PresetPathBlock, a2: PresetPathBlock) => a1.name.localeCompare(a2.name));
            }
            return [];
        }

        private static canBePresetPathSink(block: Application.Models.PresetPathBlock, presetPathType: string) {
            return PresetPathBlock.isSink(block) ||
                (PresetPathBlock.isMiddleBlock(block)
                    && (presetPathType === ConnectionType.TSOIP && !BlockTypeNaturalKey.isSrtRx(block.blockTypeNaturalKey))
                    || (presetPathType !== ConnectionType.TSOIP && BlockTypeNaturalKey.isSrtRx(block.blockTypeNaturalKey)));
        }

        private static canBePresetPathSource(block: Application.Models.PresetPathBlock, presetPathType: string) {
            return PresetPathBlock.isSource(block) ||
                (PresetPathBlock.isMiddleBlock(block)
                    && (presetPathType === ConnectionType.TSOIP || block.blockTypeNaturalKey === BlockTypeNaturalKey.SRT_GW_TX_LSTN));
        }
    }
}
